// import PropTypes from "prop-types";
import React, { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ReactSVG } from "react-svg";
import { RootState } from "../store";
import useAppDispatch from "../hooks/useAppDispatch";
import { getProductsPurchaseList } from "../store/action/products";
import { payloadProduct } from "../types/products";
import { useTranslation } from "react-i18next";

interface PropType {
  limit: number;
  type: number;
}

const Maintenance: FC<PropType> = ({ limit, type }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const products = useSelector(
    (state: RootState) => state.product.productPurchase,
  );

  const getProductsLists = async () => {
    const payload: payloadProduct = {
      pageSize: limit,
      pageNo: 0,
      orderDirection: "",
      categoryId: 0,
      displayType: type,
      priceTo: 0,
      priceFrom: 0,
      orderColumn: "Price",
    };
    await dispatch(getProductsPurchaseList(payload));
  };

  useEffect(() => {
    getProductsLists();
  }, []);

  if (!products?.length) return <p>{t("no products found")}</p>;

  return (
    <div className="featured-product-area space-y--40">
      <div className="container">
        <div className="row">
          <div className="col-12">
            {/* section title */}
            <h2 className="section-title space-mb--25">
              {t("maintenance")}{" "}
              <Link to={process.env.PUBLIC_URL + "/products/maintenance"}>
                {t("view all")}{" "}
                <span>
                  <ReactSVG
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/img/icons/arrow-right.svg"
                    }
                  />
                </span>
              </Link>
            </h2>
            <div className="featured-product-wrapper space-mb-m--15">
              <div className="row row-5">
                {products.map((item) => {
                  return (
                    <div className="col-6" key={item.id}>
                      <div className="grid-product space-mb--20">
                        <div className="grid-product__image">
                          <Link
                            to={
                              process.env.PUBLIC_URL +
                              `/product/maintenance/${item.id}`
                            }
                          >
                            <img
                              src={item.imageUrl}
                              className="img-fluid"
                              alt=""
                            />
                          </Link>
                        </div>
                        <div className="grid-product__content">
                          <h3 className="title">
                            <Link
                              to={
                                process.env.PUBLIC_URL +
                                `/product/maintenance/${item.id}`
                              }
                            >
                              {item.name}
                            </Link>
                          </h3>
                          <span className="point">{item.pv} PV</span>
                          <div className="price">
                            {t("usd")} {item.price}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Maintenance;
